<script>
import emit from '@ubic/vue-ui/helpers/emit';
import IconCalendarPlus from '@/components/icons/CalendarPlus';

const handleChangeYear = context => val => emit(context.listeners, 'changeyear', val);
const handleSave = context => () => emit(context.listeners, 'save');
const handleUpdate = context => () => emit(context.listeners, 'update');
const handleAdd = context => () => emit(context.listeners, 'add');

export default {
  functional: true,
  props: {
    year: {
      type: Number,
      required: true,
    },
    ranges: {
      type: Array,
      required: true,
    },
    initial: {
      type: Array,
      default: () => ([]),
    },
    same: {
      type: Boolean,
      default: false,
    },
    fetching: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  render (h, context) {
    const { $style, props } = context;
    const { canEdit, saving, same, initial, fetching } = props;

    return (
      <div class={$style.wrapper}>
        {initial.length > 0
          && !same
          && canEdit
          && (
            <u-btn
              onClick={handleUpdate(context)}
            >
              {saving ? (
                <u-spinner inline />

              ) : 'Обновить'}
            </u-btn>
          )}

        {initial.length === 0
          && !fetching
          && canEdit
          && (
            <u-btn
              onClick={handleSave(context)}
            >
              {saving ? (
                <u-spinner inline />
              ) : 'Сохранить'}
            </u-btn>
          )}

        <div class={$style.dateFilters}>
          <u-select
            value={props.year.toString()}
            options={props.ranges}
            onInput={handleChangeYear(context)}
          />
          &nbsp;
          {canEdit && (
            <u-btn
              appearance="outline"
              size="square"
              onClick={handleAdd(context)}
            >
              <IconCalendarPlus />
            </u-btn>
          )}
        </div>
      </div>
    );
  },
};
</script>

<style lang="scss" module>
.wrapper {
  align-items: center;
  display: flex;
  justify-content: stretch;
  margin-bottom: 1.5rem;
}

.dateFilters {
  margin-left: auto;
}
</style>
